import { Controller } from "@hotwired/stimulus"

// Xキーワード分析のセクション集計(TwKeywordSectionAggregation)の完了待ち。
// frame-poll と違い、フレームを無条件に再読込せず status エンドポイント(JSON)を定期的に確認し、
// 集計が終わった(in_progress=false)ときだけ 1 回フレームを再読込する。
// 推移チャートのように再描画コストが高いセクションで「描画 → 更新中 → 描画」の繰り返しを起こさないため。
// 再読込後のレスポンスにこのコントローラーが含まれなければ disconnect で自動停止する。
export default class extends Controller {
  static values = {
    statusUrl: String,   // 状態確認用 JSON エンドポイント(fromDate/toDate 付き)
    frameUrl: String,    // 完了時に再読込するフレームの src(show.html.erb の src と同じ URL)
    interval: { type: Number, default: 4000 },
    timeout: { type: Number, default: 900000 },
  }

  connect() {
    this.timer = setInterval(() => this.check(), this.intervalValue)
    this.deadline = setTimeout(() => this.stop(), this.timeoutValue)
  }

  disconnect() {
    this.stop()
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    if (this.deadline) clearTimeout(this.deadline)
    this.timer = null
    this.deadline = null
  }

  async check() {
    try {
      const res = await fetch(this.statusUrlValue, { headers: { Accept: "application/json" } })
      if (!res.ok) return
      const data = await res.json()
      if (data.in_progress === false) this.reloadFrame()
    } catch (_e) {
      // ネットワーク一時失敗は次回ポーリングで回復
    }
  }

  reloadFrame() {
    this.stop()
    const frame = this.element.closest("turbo-frame")
    if (!frame) return

    // frame.src は属性値(相対 URL)を返すので、絶対 URL に正規化してから比較する
    const target = new URL(this.frameUrlValue, window.location.origin).href
    const current = frame.src ? new URL(frame.src, window.location.origin).href : null
    if (current === target) {
      frame.reload()
    } else {
      frame.src = target
    }
  }
}
